// import { ExtraOptions, RouterModule, Routes } from "@angular/router";
// import { NgModule } from "@angular/core";
// import {
//   NbAuthComponent,
//   NbLoginComponent,
//   NbLogoutComponent,
//   NbRegisterComponent,
//   NbRequestPasswordComponent,
//   NbResetPasswordComponent,
// } from "@nebular/auth";

// export const routes: Routes = [
//   {
//     path: "pages",
//     loadChildren: () =>
//       import("./pages/pages.module").then((m) => m.PagesModule),
//   },

// const config: ExtraOptions = {
//   useHash: false,
// };

// @NgModule({
//   imports: [RouterModule.forRoot(routes, config)],
//   exports: [RouterModule],
// })
// export class AppRoutingModule {}
// // import { ExtraOptions, RouterModule, Routes } from "@angular/router";
// // import { NgModule } from "@angular/core";
// // import { TablesComponent } from "./pages/tables/tables.component";
// // import { LoginComponent } from "./pages/tables/login/login.component";
// // import { ForgotpasswordComponent } from "./pages/tables/forgotpassword/forgotpassword.component";
// // import { ResetpasswordComponent } from "./pages/tables/resetpassword/resetpassword.component";

// // export const routes: Routes = [
// //   {
// //     path: "",
// //     loadChildren: () =>
// //       import("./pages/pages.module").then((m) => m.PagesModule),
// //   },
// //   {
// //     path: "",
// //     component: TablesComponent, // Assuming TablesComponent is your main component
// //     children: [
// //       {
// //         path: "login",
// //         component: LoginComponent,
// //       },
// //       {
// //         path: "forgotpassword",
// //         component: ForgotpasswordComponent,
// //       },
// //       {
// //         path: "resetpassword",
// //         component: ResetpasswordComponent,
// //       },
// //     ],
// //   },
// //   { path: "", redirectTo: "pages", pathMatch: "full" }, //pages
// //   { path: "**", redirectTo: "pages" },
// // ];

// // const config: ExtraOptions = {
// //   useHash: false,
// // };

// // @NgModule({
// //   imports: [RouterModule.forRoot(routes, config)],
// //   exports: [RouterModule],
// // })
// // export class AppRoutingModule {}

//Customise app-routing for auth
import { ExtraOptions, RouterModule, Routes } from "@angular/router";
import { NgModule } from "@angular/core";
import { AuthModule } from "./auth/auth.module";
import { SuperloginComponent } from "./auth/superlogin/superlogin.component";
import { ForgotpasswordComponent } from "./auth/forgotpassword/forgotpassword.component";
import { ResetpasswordComponent } from "./auth/resetpassword/resetpassword.component";

export const routes: Routes = [
  {
    path: "pages",
    loadChildren: () =>
      import("./pages/pages.module").then((m) => m.PagesModule),
  },
  {
    path: "auth",
    loadChildren: () => import("./auth/auth.module").then((m) => m.AuthModule),
  },

  {
    path: "auth",
    component: AuthModule, // Use AuthModule as the component
    children: [
      {
        path: "",
        redirectTo: "login", // Redirect to login page by default when navigating to /auth
        pathMatch: "full",
      },
      {
        path: "login",
        component: SuperloginComponent,
      },
      {
        path: "forgotpassword",
        component: ForgotpasswordComponent,
      },
      {
        path: "resetpassword",
        component: ResetpasswordComponent,
      },
    ],
  },
  { path: "", redirectTo: "auth", pathMatch: "full" }, // Redirect to 'pages' by default
  { path: "**", redirectTo: "pages" }, // Redirect to 'pages' for any unmatched routes
];
const config: ExtraOptions = {
  useHash: false,
};

@NgModule({
  // imports: [RouterModule.forRoot(routes, config)],
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
